import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 3l1 6l2 -3.75l2 3.75l1 -6","key":"svg-0"}],["path",{"d":"M16 21l-4 -8l-4 8l4 -2l4 2","key":"svg-1"}]]

const IconNavigationWest = createReactComponent('outline', 'navigation-west', 'NavigationWest', __iconNode);

export default IconNavigationWest;